import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { HOME } from "@/constants/testIds";
import { clearConsultant } from "@/lib/dailyCard";

const FIRSTNAME_KEY = "arcana.firstName.v1";

export const Header = () => {
  const { t } = useLanguage();
  const { pathname } = useLocation();
  const nav = useNavigate();
  const [firstName, setFirstName] = useState("");

  useEffect(() => {
    setFirstName(window.localStorage.getItem(FIRSTNAME_KEY) || "");
  }, [pathname]);

  const handleNewConsultant = () => {
    clearConsultant();
    setFirstName("");
    nav("/", { replace: true });
  };

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-oxblood/70 border-b border-gold/15">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 md:px-12 py-4 gap-4">
        <Link to="/" className="flex items-baseline gap-3 group" data-testid={HOME.brand}>
          <span className="rune text-2xl md:text-3xl">✦</span>
          <span className="font-serif italic font-light text-xl md:text-2xl text-ivory group-hover:text-gold transition-colors duration-300">
            {t.brand}
          </span>
        </Link>

        <nav className="flex items-center gap-4 md:gap-6 text-[0.7rem] tracking-[0.32em] uppercase font-sans">
          <Link
            to="/"
            className={`transition-colors duration-300 ${
              pathname === "/" ? "text-gold" : "text-ivory/60 hover:text-ivory"
            }`}
          >
            {t.nav.home}
          </Link>
          <div className="hidden sm:block h-4 w-px bg-gold/30" />
          <Link
            to="/contact"
            data-testid="header-contact"
            className={`transition-colors duration-300 ${
              pathname === "/contact" ? "text-gold" : "text-ivory/60 hover:text-ivory"
            }`}
          >
            {t.nav.contact}
          </Link>
          {firstName && (
            <>
              <div className="hidden sm:block h-4 w-px bg-gold/30" />
              <button
                type="button"
                onClick={handleNewConsultant}
                data-testid="header-new-consultant"
                title={t.nav.newConsultant}
                className="text-ivory/60 hover:text-gold transition-colors duration-300"
              >
                ↺ {t.nav.newConsultant}
              </button>
            </>
          )}
          <div className="hidden sm:block h-4 w-px bg-gold/30" />
          <LanguageSwitcher />
        </nav>
      </div>
      <div className="gold-hairline" />
    </header>
  );
};

export default Header;
